import { useDebouncedValue } from "@mantine/hooks";
import { GraphQL } from "@rpi/openapi-api";
import React from "react";
import { RpiFilterV2 } from "../../components/search-filter/RpiSearchFilterTypes";
import { useAuthUser } from "../../hooks/useAuthUser";
import { optArray } from "../../utils/misc.util";

export const usePaymentFilters = () => {
  const user = useAuthUser();

  const [customersSearch, setCustomersSearch] = React.useState("");
  const [debouncedCustomersSearch] = useDebouncedValue(customersSearch, 250);

  const { data, isLoading } = GraphQL.useAdminListCustomersQuery(
    { input: debouncedCustomersSearch },
    { enabled: user.is.SUPER_ADMIN }
  );
  const customers = React.useMemo(() => (data?.adminListCustomers || []).map((customer) => customer.publicId), [data]);

  return React.useMemo(() => {
    return RpiFilterV2.createConfigs<GraphQL.PaymentSearchFields>([
      ...optArray<RpiFilterV2.Config<GraphQL.PaymentSearchFields>>(user.is.SUPER_ADMIN, [
        {
          type: "dropdown",
          label: "Customer",
          field: GraphQL.PaymentSearchFields.CustomerPublicId,
          data: customers,
          onSearch: setCustomersSearch,
          isLoading: isLoading,
        },
        {
          type: "text",
          label: "Braintree Transaction",
          field: GraphQL.PaymentSearchFields.BraintreeTransactionId,
        },
      ]),
      {
        type: "select",
        label: "Transaction type",
        field: GraphQL.PaymentSearchFields.TransactionType,
        data: Object.values(GraphQL.TransactionType),
      },
      {
        type: "date",
        label: "Created at",
        field: GraphQL.PaymentSearchFields.CreatedAt,
      },
      {
        type: "date",
        label: "Updated at",
        field: GraphQL.PaymentSearchFields.UpdatedAt,
      },
    ]);
  }, [user.is, customers, isLoading]);
};
